import { Box, Container, Typography, type SxProps } from '@mui/material'
import type { ReactNode } from 'react'

interface PageContainerProps {
  title?: string
  subtitle?: string
  action?: ReactNode
  children: ReactNode
  maxWidth?: 'sm' | 'md' | 'lg'
  disableGutterTop?: boolean
  sx?: SxProps
}

/**
 * Standard page wrapper: constrained width, consistent spacing, and an
 * optional header row with title/subtitle and an action slot.
 */
export default function PageContainer({
  title,
  subtitle,
  action,
  children,
  maxWidth = 'md',
  disableGutterTop,
  sx,
}: PageContainerProps) {
  return (
    <Container maxWidth={maxWidth} sx={{ pt: disableGutterTop ? 0 : 3, pb: 6, ...sx }}>
      {(title || action) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            mb: 3,
          }}
        >
          <Box>
            {title && (
              <Typography variant="h4" component="h1" fontWeight={700}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
        </Box>
      )}
      {children}
    </Container>
  )
}
